import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import MainButtonSet from '../../components/mainButtonSet';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import switchBillingToService from '../../shared/switchBillingToService';
import template from './companyAccount.vue';

@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
    },
})
export default class CompanyAccount extends Vue {
    userAccount: any = {};
    showErrTip: boolean = false;
    errorText: String = '';
    billToId: any = '';

    mounted() {
        this.init();
    }

    init() {
        this.getUserBillToId().then(
            (res: any) => {
                if (res.data.billing) {
                    this.billToId = res.data.billing.location_id;
                    this.getCompanyAccount();
                }
            },
            (err: any) => {}
        );
    }

    getCompanyAccount() {
        tmsServiceBackend
            .get(`cpv2/settings/companyAccount/getCompanyAccountInfo?billto_id=` + this.billToId)
            .then(
                (res: any) => {
                    this.userAccount = res.data.data;
                },
                (err: any) => {
                    this.showErrorFun('Get account error.');
                }
            );
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    async getUserBillToId() {
        return await switchBillingToService.post();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/companyAccount/index.ts